import title_US from './../config/title_US.json';

const RbTitle = function(){

	//Setting defaultLocale to en_US
	var defaultLocale = "title_US";

	//Setting userLocale to en_US unless otherwise changed by the user
	var userLocale = "title_US";

	var getBundle = function(locale){
		switch(locale){
			case "title_US" : return title_US;
			default: return title_US;
		}
    }
    
	var replaceDynamicText = function(originalString,replaceStringArray)
	{
		for(var i=0;i<replaceStringArray.length;i++)
		{
		   var val = "{"+i+"}";
		   originalString = originalString.split(val).join(replaceStringArray[i]);
		}
		return originalString;
	}
	return {
		getText:function(rawTxt,replaceStringArray=[]){
			try{
				var rb = getBundle(userLocale);
				if(rb[rawTxt]){
					return (replaceStringArray.length>0) ? replaceDynamicText(rb[rawTxt],replaceStringArray) : rb[rawTxt];
				}
				else if(getBundle(defaultLocale)[rawTxt]){
					return (replaceStringArray.length>0) ? replaceDynamicText(getBundle(defaultLocale)[rawTxt],replaceStringArray) : getBundle(defaultLocale)[rawTxt];
				}
			}catch(e){
				console.error(e);
			}

			return (replaceStringArray.length>0) ? replaceDynamicText(rawTxt,replaceStringArray) : rawTxt;
		},
		setLocale:function(locale){
			userLocale = locale;
		},
		getLocale:function(){
			return userLocale;
		}
	}
}();

export default RbTitle;


// WEBPACK FOOTER //
// ./src/util/RbTitle.js